import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
export function TermsPage() {
  // Scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0B1A2E] text-[#F1F5F9] flex flex-col selection:bg-[#2DD4BF]/30 selection:text-white" data-id="element-166">
      <main className="flex-grow max-w-3xl mx-auto w-full px-4 py-16 md:py-24" data-id="element-167">
        <Link to="/" className="inline-flex items-center gap-2 text-[#2DD4BF] hover:text-[#14B8A6] hover:underline mb-12 transition-colors font-medium" data-id="element-168">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-169" />
          <span data-id="element-170">Back to Home</span>
        </Link>

        <h1 className="text-4xl md:text-5xl font-serif font-bold mb-8" data-id="element-171">
          Terms of Service
        </h1>

        <div className="space-y-8 text-[#94A3B8] leading-relaxed" data-id="element-172">
          <p data-id="element-173">Last updated: {new Date().toLocaleDateString()}</p>

          <section data-id="element-174">
            <h2 className="text-2xl font-serif font-bold text-[#F1F5F9] mb-4" data-id="element-175">
              1. Acceptance of Terms
            </h2>
            <p className="mb-4" data-id="element-176">
              By accessing and purchasing the ADHD Executive Function Toolkit,
              you accept and agree to be bound by the terms and provision of
              this agreement. In addition, when using these particular services,
              you shall be subject to any posted guidelines or rules applicable
              to such services.
            </p>
          </section>

          <section data-id="element-177">
            <h2 className="text-2xl font-serif font-bold text-[#F1F5F9] mb-4" data-id="element-178">
              2. Digital Product License
            </h2>
            <p className="mb-4" data-id="element-179">
              Upon purchase, you are granted a single, non-transferable,
              non-exclusive license to use the digital toolkit for personal,
              non-commercial purposes. You may not:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-180">
              <li data-id="element-181">Modify or copy the materials for commercial use.</li>
              <li data-id="element-182">
                Share, distribute, or resell the digital files to third parties.
              </li>
              <li data-id="element-183">
                Remove any copyright or other proprietary notations from the
                materials.
              </li>
              <li data-id="element-184">
                Transfer the materials to another person or "mirror" the
                materials on any other server.
              </li>
            </ul>
          </section>

          <section data-id="element-185">
            <h2 className="text-2xl font-serif font-bold text-[#F1F5F9] mb-4" data-id="element-186">
              3. Refund Policy
            </h2>
            <p className="mb-4" data-id="element-187">
              Due to the digital nature of the ADHD Executive Function Toolkit,
              all sales are final. Once the digital files have been downloaded
              or accessed, we cannot offer refunds, exchanges, or cancellations.
              If you experience technical issues accessing your purchase, please
              contact our support team.
            </p>
          </section>

          <section data-id="element-188">
            <h2 className="text-2xl font-serif font-bold text-[#F1F5F9] mb-4" data-id="element-189">
              4. Disclaimer
            </h2>
            <p className="mb-4" data-id="element-190">
              The materials within the ADHD Executive Function Toolkit are
              provided on an 'as is' basis. The toolkit is designed for
              educational and organizational purposes and does not constitute
              medical advice, diagnosis, or treatment. Always seek the advice of
              your physician or other qualified health provider with any
              questions you may have regarding a medical condition.
            </p>
          </section>

          <section data-id="element-191">
            <h2 className="text-2xl font-serif font-bold text-[#F1F5F9] mb-4" data-id="element-192">
              5. Contact Information
            </h2>
            <p className="mb-4" data-id="element-193">
              If you have any questions about these Terms, please contact us at:
              <br data-id="element-194" />
              <a href="mailto:support@adhdtoolkit.com" className="text-[#2DD4BF] hover:underline mt-2 inline-block" data-id="element-195">
                support@adhdtoolkit.com
              </a>
            </p>
          </section>
        </div>
      </main>

      <Footer data-id="element-196" />
    </div>;
}